import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.fullStressScoring.loading;
export const selectFullStressErrorMessage = (state: RootState) =>
  state.fullStressScoring.error;
export const fullStressScoringResponse = (state: RootState) =>
  state.fullStressScoring.fullStressScoringResponse;
